import aggiungi from  './aggiungi'

export default [
  // always
  {
    'key': 'fatture-acquisto-button-aggiungi',
    'label': 'AGGIUNGI MANUALMENTE FATTURA',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-plus',
    'type': 'operation',
    'method': aggiungi,
    'display': 'always'
  },

]
